import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { afterHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/after-hook.js'
import { beforeHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/before-hook.js'
import { lifecycleContext } from '@next-adapter/generators/actions/lifecycle-hook-emissions/lifecycle-context.js'
import { lifecycleHookImport } from '@next-adapter/generators/actions/lifecycle-hook-emissions/lifecycle-hook-import.js'
import { renderGenDeleteContentRenderer } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-delete-content.js'

export function genDeleteContent(ctx: EntityCtx): string {
  const deleteContext = lifecycleContext(
    ctx.plural,
    `,\n      entityId: id,\n      changedFields: []`
  )

  return renderGenDeleteContentRenderer({
    kind: 'renderGenDeleteContentServerActionTemplate',
    props: {
      ctxTableVar: ctx.tableVar,
      ctxCacheInvalidationFn: ctx.cacheInvalidationFn,
      ctxCamelPlural: ctx.camelPlural,
      lifecycleHookImport: lifecycleHookImport(),
      ctxSingular: ctx.Singular,
      deleteContext: deleteContext,
      beforeHook: beforeHook('beforeDelete', 'lifecycleContext'),
      ctxPlural: ctx.plural,
      afterHook: afterHook(
        'afterDelete',
        renderGenDeleteContentRenderer({ kind: 'renderGenDeleteContentTemplate' })
      ),
      ctxSingularText: ctx.singular
    }
  })
}
